import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './StartNoteWarning.module.css';
import { StatusCritical } from '_components';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { noteActions } from '_actions';


class PatientHomeAdmissionStartNoteWarnings extends React.Component {

    render() {
        return (
            <div className={styles.warning_wrapper}>
                <div className={styles.warning_body}>
                    {(this.props.warning === 3 || this.props.warning === 5) &&
                        <div>
                            <StatusCritical title='Error' size='smaller' className={styles.icon} />
                            <span className={styles.message}>This admission currently has a note in-progress.  The note must be completed prior to initiating a new note.</span>
                        </div>
                    }
                    {(this.props.warning === 4 || this.props.warning === 5) &&
                        <div>
                            <StatusCritical title='Error' size='smaller' className={styles.icon} />
                            <span className={styles.message}>
                                Your CETS hours are not up-to-date.  You must enter hours prior to starting a new note.
                                Click <a style={{ color: 'red', textDecoration: 'underline' }} className={styles.message_link} href={this.props.cetsUrl} target='_blank' rel="noopener noreferrer">here</a> to enter hours.
                            </span>
                        </div>
                    }
                    {(this.props.warning === 6) &&
                        <div>
                            <StatusCritical title='Error' size='smaller' className={styles.icon} />
                            <span className={styles.message}>This admission requires a fully licensed PT/OT/SLP in order to perform an eval.</span>
                        </div>
                    }
                    {(this.props.warning === 7) &&
                        <div>
                            <StatusCritical title='Error' size='smaller' className={styles.icon} />
                            <span className={styles.message}>Only a fully licensed therapist, graduate, or student may perform an eval.</span>
                        </div>
                    }
                    {(this.props.warning === 8) &&
                        <div>
                            <StatusCritical title='Error' size='smaller' className={styles.icon} />
                            <span className={styles.message}>This admission currently has a note in-progress. Go to the CDV to scribe this note.</span>
                        </div>
                    }

                </div>
                <div className={styles.warning_close}>
                    <span title="Clear Warnings" className={styles.close} onClick={() => { this.props.clearWarnings({ epno: this.props.id }) }}>
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </span>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearWarnings: bindActionCreators(noteActions.startNoteWarningClear, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    return {
        cetsUrl: state.entities.masterData.PROPS['PTERO_CETS_URL'].PRVALUE,
        warning: state.ui.admissions[ownprops.id].startNoteWarning
    };
}

const connectedPatientHomeAdmissionStartNoteWarnings = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionStartNoteWarnings);
export { connectedPatientHomeAdmissionStartNoteWarnings as PatientHomeAdmissionStartNoteWarnings };

